import style from './index.module.scss';
import MastHead from '@components/MastHead';
import Footer from '@components/Footer';
import SplitFooter from '@components/SplitFooter';

import { useParamCheck } from '@context/ParamCheck';

import { useRouter } from 'next/router';

import { MASTHEAD_ON_FRONT, IS_SPLIT_FOOTER, ENABLE_HOLDING_PAGE, CSS_INSTANCE_CLASS_TARGET, MENU_STICKY } from '@lib/constants';
import HoldingPage from '@components/HoldingPage';

const MainLayout = ({ children }) => {
	const { hideMasthead, previewProspectus } = useParamCheck();

	const router = useRouter();

	const paths = [
		'/everything',
		'/personalise',
		'/configure',
		'/auth/login',
		'/auth/forgotten-password',
		'/auth/register',
		'/auth/reset-password',
	];

	const classes = {
		'/basket': 'personalise',
		'/personalise': 'personalise',
		'/advisor': 'personalise',
	};

	return (
		<>
			{ENABLE_HOLDING_PAGE && !previewProspectus ? (
				<HoldingPage />
			) : (
				<>
					{!hideMasthead &&
					(router.pathname !== '/' || (router.pathname === '/' && 'true' === MASTHEAD_ON_FRONT)) ? (
						<MastHead
							hideMenuItems={router.pathname === '/'}
							isSecondaryStyle={paths.includes(router.pathname)}
						/>
					) : (
						''
					)}
					<main
						id="main"
						className={`${classes[router.pathname] ? style[classes[router.pathname]] : ''} ${hideMasthead ? 'hideMasthead' : ''} ${CSS_INSTANCE_CLASS_TARGET} ${MENU_STICKY ? 'menuSticky' : ''}`}
					>
						{children}
					</main>
					{!hideMasthead ? !IS_SPLIT_FOOTER ? <Footer /> : <SplitFooter /> : ''}
				</>
			)}
		</>
	);
};
export default MainLayout;
